import { DAILY_BONUS, dailyGoalsFor, missionsFor, type Progress } from '../sim/missions';
import { t, tId } from './i18n';

/** Local calendar day key (YYYY-MM-DD). Daily goals reset at local midnight. */
export function todayKey(now = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** Renders the environment's missions and today's goals into a list element. */
export function renderGoals(list: HTMLElement, envId: string, progress: Progress): void {
  const rows: string[] = [];
  for (const m of missionsFor(envId)) {
    const done = progress.done.includes(m.id);
    rows.push(`<li class="${done ? 'is-done' : ''}"><span class="goal-mark" aria-hidden="true">${done ? '✓' : '○'}</span><span>${tId(`mission.${m.id}`, m.text)}</span><b>+${m.reward}</b></li>`);
  }
  const totals = progress.daily.totals;
  const daily = dailyGoalsFor(progress.daily.day).map((g) => {
    const done = progress.daily.claimed.includes(g.id);
    const have = Math.min(g.target, totals[g.measure]);
    return `<li class="is-daily ${done ? 'is-done' : ''}"><span class="goal-mark" aria-hidden="true">${done ? '✓' : '○'}</span><span>${tId(`daily.${g.id}`, g.text)} <small>${have}/${g.target}</small></span><b>+${g.reward}</b></li>`;
  });
  const bonus = progress.daily.bonus ? ' is-done' : '';
  list.innerHTML = `
    <li class="goal-head">${t('goals.missions')}</li>${rows.join('')}
    <li class="goal-head">${t('goals.today')}</li>${daily.join('')}
    <li class="is-daily${bonus}"><span class="goal-mark" aria-hidden="true">${progress.daily.bonus ? '✓' : '○'}</span><span>${t('goals.all-three')}</span><b>+${DAILY_BONUS}</b></li>`;
}
